module.exports = __webpack_public_path__ + "img/ygjc0016.be4d89ef.gif";